export default __webpack_public_path__ + "static/media/materials.12bc62d0.jpg";